export default {
  titleSingular: 'User manager',
  titlePlural: 'User managers',
  alertText: `The current User Manager cannot be changed because they are not associated
            with any custodian. To link the user to a new User Manager or remove the
            existing one, first assign the current User Manager to a custodian or unlink
            the user from them using Swagger.`,
  email: 'Email',
  userName: 'Username',
  number: 'Phone number',
};
